import React, { useState } from "react";
import BotResponseText from './BotResponseText';
import { CheckCircle } from "lucide-react";
import { useSelector } from "react-redux";
import AudioResponsePlayer from './AudioResponsePlayer';
import { selectIsVoiceFlow, selectVoiceFlowLocks, selectSelectedChatId } from '../../../../store/features/message/textContentSelectors';
import useLocalization from '../../../../hooks/useLocalization';
import { useAppContext } from "../../../../context/AppContext";
import PropTypes from "prop-types";



const GrievanceInfoCard = ({
    grievance_bucket,
    updated_grievance,
    onVerifyClick,
    field_form,
    isMostRecent,
    contentAudio,
    mandatory_data_present,
    field_form_list,
    isNotSubcategory=false
}) => {
    const [showText, setShowText] = useState(true);
    const { t } = useLocalization();
    const { selectedLanguageData } = useAppContext();

    const selectedChatId = useSelector(selectSelectedChatId);
    const isVoiceFlow = useSelector(selectIsVoiceFlow);
    const isVoiceFlowLocked = useSelector(selectVoiceFlowLocks(selectedChatId));

    const isFieldFormContainsData = () => Array.isArray(field_form) && field_form.length > 0;
    return (
        <div className=" space-y-3">
            <h3 className="text-lg font-bold mb-2 mt-2 flex gap-2 items-center"> <CheckCircle className="w-5 h-5 text-green-600" /> {t('grievanceInformation')}</h3>

            <div className="dark:bg-[#232323] border rounded-lg shadow-sm p-3 bg-[#F7FFF2] border-[#9EB3FF]">
                <h4 className="text-md font-semibold text-blue-700 dark:text-blue-400">{t('grievanceSummery')}</h4>
                <div className="space-y-2 text-sm max-h-60 overflow-auto pr-2 ">
                    <BotResponseText text={updated_grievance || "No summary available."} />
                </div>
            </div>

            {!isVoiceFlow && !isVoiceFlowLocked && isFieldFormContainsData() && mandatory_data_present && (
                <AudioResponsePlayer
                    isAutoPlay={isVoiceFlow && isMostRecent}
                    contentAudio={contentAudio}
                    showText={showText}
                    setShowText={setShowText}
                />
            )}

            <div className="bg-white dark:bg-[#232323] border rounded-lg shadow-sm">
                <h4 className="text-md font-semibold text-[#1334A8] px-3 py-1 border border-b-[#D9D9D9]">
                    {t('categorization.title')}
                </h4>
                <div className="space-y-2 text-sm p-3">
                    {Object.entries(grievance_bucket)
                        // .filter(([k, v]) => k !== 'Description' && v)
                        .filter(([k, v]) => {
                            if (k === 'Description' || !v) return false;
                            if (isNotSubcategory && k === 'SubCategory') return false;
                            return true;
                        })
                        .map(([k, v], i) => (
                            <div key={k} >
                                <p className="w-40 font-medium text-gray-800 dark:text-gray-200">
                                    {t(`categorization.${k}`) || k}
                                </p>
                                <p className="text-gray-700 dark:text-gray-300 bg-[#EBF2FF] border border-[#6B71EA] px-3 py-[6px] rounded-md mt-1">{String(v)}</p>
                            </div>
                        ))}
                </div>
            </div>

            {Array.isArray(field_form_list) && field_form_list.length > 0 && (
                <div className="bg-white dark:bg-[#232323] border rounded-lg shadow-sm">
                    <div className="flex justify-between items-center px-3 py-2 border-b border-[#D9D9D9]">
                        <h4 className="text-lg font-semibold text-[#1233A8] dark:text-green-400 flex items-center gap-2">
                            {t('collectedUserInformation') || 'Collected User Information'}
                        </h4>
                    </div>

                    <div className="space-y-2 text-sm max-h-60 overflow-auto p-3">
                        {field_form_list.map((item, idx) => {
                            const value =
                                item.FieldType === "Dropdown"
                                    ? item.UserInputText
                                    : item.UserInputValue;

                            return (
                                <div
                                    key={item.FieldName}
                                    className="flex flex-col sm:flex-row sm:items-center border-b border-gray-200 dark:border-gray-700 pb-1 mb-1 hover:bg-gray-50 dark:hover:bg-gray-800 rounded-md px-1"
                                >
                                    <span className="w-full sm:w-48 font-semibold text-gray-800 dark:text-gray-100">
                                        {selectedLanguageData?.code === "en" ? item.DisplayLable : item.DisplayLable_regional || item.DisplayLable}:
                                    </span>
                                    <span className="text-gray-700 dark:text-gray-300 sm:ml-2">
                                        {value || "-"}
                                    </span>
                                </div>
                            );
                        })}
                    </div>
                </div>
            )}

            <div className="text-right">
                <button
                    onClick={onVerifyClick}
                    className="inline-block px-6 py-2.5 bg-blue-600 hover:bg-blue-700 text-white text-sm font-semibold rounded-md transition duration-200 shadow-md"
                    style={{ background: "linear-gradient(to bottom, #0E369E, #007E86)" }}>
                    {t('verifyDetails')}
                </button>
            </div>

        </div>
    );
};

GrievanceInfoCard.propTypes = {
    grievance_bucket: PropTypes.object,
    updated_grievance: PropTypes.string,
    mandatory_questions_answered: PropTypes.array,
    onVerifyClick: PropTypes.func.isRequired,
    field_form: PropTypes.array,
    isMostRecent: PropTypes.bool,
    contentAudio: PropTypes.string,
    mandatory_data_present: PropTypes.bool,
    field_form_list: PropTypes.array,
};

export default GrievanceInfoCard;
